import type { SelectProps } from 'node_modules/react-day-picker/dist/esm/components/Select';
import type { FC } from 'react';

import { Select } from '@zen/DesignSystem';

import { packagingOptions } from './helpers';

const PackagingTypesSelect: FC<SelectProps> = (props) => {
  return (
    <Select
      {...props}
      labelPlacement="top"
      variant="inline"
      options={packagingOptions}
      placeholder="Select a packaging type..."
      renderMenuInPortal={true}
      shouldFilterResults={false}
      isClearable={true}
    />
  );
};

export default PackagingTypesSelect;
